import React from "react";
import { generateOTP } from 'app/services/setupWebview';
import Swal from "sweetalert2";
import { requestApi } from "app/utils/RestApi";
import appConfig from "app/config/appConfig";
import Div from "@jumbo/shared/Div";
import { Typography } from "@mui/material";
import Countdown from 'app/components/CountDown/CountDown';
import { OTP } from "app/utils/constants/endPoint";

let isGeneratingGlobal = false;

const OTPCountdown = ({ isMicrosite = true, params = {}, actionType = "TNC_REGIS", onRestart }) => {

  const maxRestartLimit = Number(appConfig.maxRestartLimit);
  const restartDelayMinutes = Number(appConfig.restartDelayMinutes);
  const [expiryTime, setExpiryTime] = React.useState(0);
  const [restartCount, setRestartCount] = React.useState(Number(localStorage.getItem(`restartCount_${actionType}`)) || 0);
  const [restartAvailableTime, setRestartAvailableTime] = React.useState(0);
  const [isTimerStopped, setIsTimerStopped] = React.useState(false);
  const hasInitialized = React.useRef(false);
  const mountedRef = React.useRef(true);

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
      isGeneratingGlobal = false;
    };
  }, []);

  React.useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;
    checkOTP()
  }, []);

  const handleRestartTimer = () => {
    let tmpRestartAvTime = 0;
    if (Date.now() < Number(localStorage.getItem(`restartAvailableTime_${actionType}`))) {
      tmpRestartAvTime = Number(localStorage.getItem(`restartAvailableTime_${actionType}`));
    }
    setRestartAvailableTime(tmpRestartAvTime);
    if (!tmpRestartAvTime) {
      localStorage.removeItem(`restartAvailableTime_${actionType}`);
      setRestartCount(0);
    }
    setIsTimerStopped(false);
  }

  const handleActiveOrExpiredOTP = (isExpired, newExpiryTime) => {
    if (!isExpired) {
      setExpiryTime(newExpiryTime);
    }
    setIsTimerStopped(isExpired);
  }

  const processExistingOTP = () => {
    const storedRestartCount = Number(localStorage.getItem(`restartCount_${actionType}`)) || 0;
    setRestartCount(storedRestartCount);
    const newExpiryTime = new Date(localStorage.getItem(`ref_otp_exp_${actionType}`)).getTime();
    const isExpired = (Date.now() > newExpiryTime);

    if (localStorage.getItem(`restartAvailableTime_${actionType}`)) {
      handleRestartTimer();
    } else if (storedRestartCount >= maxRestartLimit && isExpired) {
      startLockedTimer();
    } else if (isExpired) {
      localStorage.removeItem(`ref_otp_exp_${actionType}`);
      localStorage.removeItem(`expiryTime_${actionType}`);
      isMicrosite ? generateMicrositeOTP() : generateNonMicrositeOTP();
    } else {
      handleActiveOrExpiredOTP(isExpired, newExpiryTime);
    }
  }

  const checkOTP = () => {
    if (localStorage.getItem(`ref_otp_exp_${actionType}`)) {
      processExistingOTP();
    } else {
      isMicrosite ? generateMicrositeOTP() : generateNonMicrositeOTP();
    }
  }

  async function generateMicrositeOTP() {
    if (!localStorage.getItem('username')) {
      return;
    }
    if (isGeneratingGlobal) return;
    isGeneratingGlobal = true;
    await requestApi(OTP.GENERATE_OTP_REF, {
      data: {
        username: localStorage.getItem('username'),
        actionType: actionType
      }
    }).then(({ data }) => {
      if (!mountedRef.current) return;
      Swal.close();
      if (data.status == 'success') {
        mapTimerProps(data.data.expired_at);
      } else {
        setTimeout(() => {
          Swal.fire({
            icon: 'warning',
            text: data?.message ?? 'Gagal generate OTP',
            allowOutsideClick: false,
            confirmButtonColor: 'red'
          });
        }, 1000);
      }
    }).catch(err => {
      if (maybeEngageBlockLock(err)) {
        Swal.close();
        return;
      }
      setTimeout(() => {
        Swal.fire({
          icon: 'warning',
          text: err?.message ?? err?.data?.message ?? 'Gagal generate OTP, mohon coba beberapa saat lagi',
          allowOutsideClick: false,
          confirmButtonColor: 'red'
        });
      }, 1000);
    }).finally(() => {
      isGeneratingGlobal = false;
    });
  }

  async function generateNonMicrositeOTP() {
    if (!params.kode) {
      return;
    }
    if (isGeneratingGlobal) return;
    isGeneratingGlobal = true;

    await generateOTP(params.kode, params.nama, actionType).then((data) => {
      if (!mountedRef.current) return;
      Swal.close();
      if (data?.status === 'success') {
        mapTimerProps(data.data.expired_at);
      } else {
        setTimeout(() => {
          Swal.fire({
            icon: 'warning',
            text: data?.message ?? 'Gagal generate OTP, mohon coba beberapa saat lagi',
            allowOutsideClick: false,
            confirmButtonColor: 'red'
          });
        }, 1000);
      }
    }).catch((err) => {
      Swal.close();
      if (maybeEngageBlockLock(err)) {
        return;
      }
      setTimeout(() => {
        Swal.fire({
          icon: 'warning',
          text: err?.message ?? err?.data?.message ?? 'Gagal generate OTP, mohon coba beberapa saat lagi',
          allowOutsideClick: false,
          confirmButtonColor: 'red'
        });
      }, 1000);
    }).finally(() => {
      isGeneratingGlobal = false;
    });
  }



  const mapTimerProps = (expired_at) => {
    let tmpRestartCount = 0
    if (localStorage.getItem(`restartCount_${actionType}`)) {
      tmpRestartCount = Number(localStorage.getItem(`restartCount_${actionType}`))
    }
    let expired_date = new Date(expired_at);
    expired_date.setSeconds(expired_date.getSeconds() + 7)
    const newExpiryTime = expired_date.getTime();
    let newRestartCount = tmpRestartCount + 1;
    let newRestartAvailableTime = restartAvailableTime;

    if (restartCount >= maxRestartLimit) {
      newRestartCount = 1;
    }

    localStorage.setItem(`ref_otp_exp_${actionType}`, expired_at)
    localStorage.setItem(`expiryTime_${actionType}`, newExpiryTime.toString());
    localStorage.setItem(`restartCount_${actionType}`, newRestartCount.toString());

    setRestartCount(newRestartCount);
    setRestartAvailableTime(newRestartAvailableTime);
    setIsTimerStopped(false);
    setExpiryTime(newExpiryTime);
  }

  const maybeEngageBlockLock = (body) => {
    const blockTime = body?.data?.block_time;
    const lockedUntil = body?.data?.locked_until;
    if (!blockTime || !lockedUntil) return false;
    const until = new Date(lockedUntil).getTime();
    if (!until || until <= Date.now()) return false;
    localStorage.setItem(`restartCount_${actionType}`, String(maxRestartLimit));
    localStorage.setItem(`restartAvailableTime_${actionType}`, until.toString());
    setRestartCount(maxRestartLimit);
    setRestartAvailableTime(until);
    setIsTimerStopped(true);
    return true;
  };

  const Timer = React.useCallback(
    () => {
      return <Countdown key={expiryTime} expiryTime={expiryTime} callBackTimer={(bool) => {
        setTimeout(() => {
          if (restartCount >= maxRestartLimit && !localStorage.getItem(`restartAvailableTime_${actionType}`)) {
            startLockedTimer()
          } else {
            setIsTimerStopped(bool)
          }
        }, 1000);
      }} />
    },
    [expiryTime],
  )

  const startLockedTimer = () => {
    const tmpRestartAvailableTime = Date.now() + (restartDelayMinutes * 60 * 1000);

    localStorage.setItem(`restartAvailableTime_${actionType}`, tmpRestartAvailableTime.toString());
    setRestartAvailableTime(tmpRestartAvailableTime)
  }

  const TimerRestart = React.useCallback(
    () => {
      return <Countdown key={'2'} defaultM={5} expiryTime={restartAvailableTime} callBackTimer={() => {
        if (localStorage.getItem(`restartAvailableTime_${actionType}`)) {
          localStorage.removeItem(`restartAvailableTime_${actionType}`);
          setRestartAvailableTime(0)
        }
        if (!isTimerStopped) {
          setIsTimerStopped(true)
        }
        if (Number(localStorage.getItem(`restartCount_${actionType}`)) > 0) {
          localStorage.setItem(`restartCount_${actionType}`, '0')
          setRestartCount(0)
        }
      }} />
    },
    [restartAvailableTime],
  )

  const restartTimer = async () => {
    onRestart()
    const now = Date.now();
    if (!isTimerStopped) {
      //Jika klik saat timer berjalan
    } else if (restartCount >= maxRestartLimit && now < restartAvailableTime) {
      Swal.fire({
        icon: 'warning',
        text: `Tidak dapat mengirim kembali OTP: Batas kirim ulang maksimum (${maxRestartLimit}) tercapai. Coba lagi dalam 5 menit.`,
        showConfirmButton: false
      })
    } else {
      Swal.showLoading()
      isMicrosite ? generateMicrositeOTP() : generateNonMicrositeOTP();
    }
  }

  return (
    <>
      {
        restartAvailableTime ?
          <Div>
            <Div sx={{ mt: 3 }}>
              <Div className='dis-flex-center'>
                <Typography fontSize={14} fontWeight={500} color={'#979797'} textAlign={"center"}>Terlalu banyak percobaan pengiriman</Typography>
              </Div>
            </Div>
            <Div>
              <Div className='dis-flex-center'>
                <Typography fontSize={14} fontWeight={500} color={'#979797'}>
                  Kirim kembali dalam
                </Typography>
                <Typography fontSize={14} fontWeight={500} color={'#979797'}>:&nbsp;</Typography>
                {
                  TimerRestart()
                }
              </Div>
            </Div>
          </Div>
          :
          <>
            <Div sx={{ mt: 3 }}>
              <Div className='dis-flex-center'>
                <Typography fontSize={14} fontWeight={500} color={'#979797'} textAlign={"center"}>Tidak mendapatkan OTP?</Typography>
              </Div>
            </Div>
            <Div>
              <Div className='dis-flex-center'>
                {
                  isTimerStopped ? (
                    <Typography style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={restartTimer} fontSize={14} fontWeight={500} color={'#FF6464'} textAlign={"center"}>Kirim Ulang</Typography>
                  )
                    :
                    <>
                      <Typography fontSize={14} fontWeight={500} color={'#979797'}>
                        Kirim ulang dalam
                      </Typography>
                      <Typography fontSize={14} fontWeight={500} color={'#979797'}>:&nbsp;</Typography>
                      {Timer()}
                      <Typography fontSize={14} fontWeight={500} color={'#979797'}>&nbsp;</Typography>
                      ({(restartCount || 1)}/{maxRestartLimit})
                    </>
                }
              </Div>
            </Div>
          </>
      }
    </>
  )
}

export default OTPCountdown;
